export default function ContractorMainDetails(props) {

  var styles = {
    grid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "24px"
    },

    card: {
      background: "#fff",
      borderRadius: "10px",
      padding: "18px",
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)"
    },

    title: {
      fontSize: "14px",
      fontWeight: 700,
      marginBottom: "14px"
    },

    field: { marginBottom: "14px" },
    label: { fontSize: "12px", color: "#555", marginBottom: "4px" },

    input: {
      width: "100%",
      padding: "9px",
      borderRadius: "8px",
      border: "1px solid rgba(0,0,0,0.18)",
      fontSize: "13px"
    },

    pill: {
      display: "inline-block",
      padding: "6px 10px",
      borderRadius: "999px",
      background: "rgba(31,111,229,0.12)",
      color: "#1f6fe5",
      fontSize: "12px",
      fontWeight: 700,
      marginRight: "8px",
      marginBottom: "8px"
    }
  };

  return (
    <div style={styles.grid}>

      {/* LEFT */}
      <div style={styles.card}>
        <div style={styles.title}>Contact & Address</div>

        <div style={styles.field}>
          <div style={styles.label}>Primary Contact</div>
          <input style={styles.input} />
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Email</div>
          <input style={styles.input} />
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Phone</div>
          <input style={styles.input} />
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Address</div>
          <input style={styles.input} />
        </div>
      </div>

      {/* RIGHT */}
      <div style={styles.card}>
        <div style={styles.title}>Services & History</div>

        <div style={styles.field}>
          <div style={styles.label}>Services Provided</div>
          <div>
            <span style={styles.pill}>Removals</span>
            <span style={styles.pill}>Electrical</span>
            <span style={styles.pill}>Data / Network</span>
          </div>
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Last Used</div>
          <input type="date" style={styles.input} />
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Approved Since</div>
          <input type="date" style={styles.input} />
        </div>

        <div style={styles.field}>
          <div style={styles.label}>Internal Notes</div>
          <input style={styles.input} />
        </div>
      </div>

    </div>
  );
}
